import styled from 'styled-components';

export default styled.div`
  background-color: ${p => p.theme.colors.neutral200};
  height: 1px;
  display: block;
  margin: ${p => p.theme.sizes.spacing8} 0px;
`;
